import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
import './caldaiaComponent.css';
import { Spinner } from 'react-bootstrap';
import AutenticationService from '../services/authservice.js';
import CaldaiaSrv from '../services/Api/Caldaia/Caldaia.js';

export default class CaldaiaComponent extends Component {
  state = {
    loading: false,
    loadingclose: false,
    msgremote: 'messaggio di ritorno',
    msgremoteopen: 'messaggio di ritorno open',
  };

  componentDidMount(props) {
    console.log('componentDidMount padre :', this.props);
    this.getControlloCaldaia();
    this.setState({
      history: this.props.history,
    });
debugger;
   // this.getOpenCloseCancello("");
   
  }

  handleError = (error, id) => {
    console.log(error);
    let mes = '';
    try {
      if (error.response.data) {
        mes = error.response.data.msgc;
      } else {
        mes = error;
      }
    } catch (e) {
      mes = error;
    }
    this.setMesRemo(mes, id);
    
    if (error.response.data.status === 403) {
      setTimeout(() => {
        if (this.state.history) this.state.history.push('/login/login');
      }, 3000);
    }
  };
  handleResponse = (response, id) => {
    debugger;
    console.log(
      'OUTPUT: CancelloComponent -> handleResponse -> response',
      response
    );
    this.setMesRemo(response.data.msgc, id);
  
  };
  setMesRemo = (mes, id) => {
    switch (id) {
      case 'open':
        this.setState({ msgremoteopen: mes, msgremote: mes });
        break;
      case 'close':
        this.setState({ msgremote: mes, msgremoteopen: mes });
        break;
        case 'onoff':
          this.setState({ msgremote: mes, msgremoteopen: mes });
          break;
      default:
        console.log('case non definito');
        break;
    }
    this.setState({ loading: false });
    this.setState({ loadingclose: false });
  };
  render() {
    return (
      <div className='CancelloComponent py-5'>
        <div className='container-fluid'>
          <section className='py-2'>
            <h3 className='mb-2 text-center'>
              <b>Controllo Caldaia</b>
            </h3>
          </section>
          <div className='row'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10 '>
              <button
                className='btn btn-primary mt-2 mybut'
                //href='#'
                onClick={this.OnCaldaia}
              >
                <div className='lead text-left'>
                  <i className='fas fa-snowflake p-2 '>
                    {this.state.loading && (
                      <Spinner animation='border' role='status'></Spinner>
                    )}
                  </i>
                </div>

                <h2>
                  <b>Premi per Accendere</b>
                </h2>
                <p className='lead text-left'><h3>{this.state.msgremoteopen}</h3></p>
              </button>
            </div>
            <div className='col-sm-1'></div>
          </div>

          <div className='row py-4'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10'>
              <button
                className='btn btn-success mt-2 mybut'
                //href='#'
                onClick={this.OffCaldaia}
              >
                <div className='lead text-left'>
                  <i className='fas fa-snowflake p-2 '>
                    {this.state.loadingclose && (
                      <Spinner animation='border' role='status'></Spinner>
                    )}
                  </i>
                </div>

                <h2>
                  <b>Premi per Spegnere</b>
                </h2>
                <p className='lead text-left'><h3>{this.state.msgremote}</h3></p>
              </button>
            </div>
            <div className='col-sm-1'></div>
          </div>
        </div>
      </div>
    );
  }
  getControlloCaldaia = (event) => {
    debugger;
    console.log(
      'OUTPUT: CancelloComponent -> OnCaldaia -> ',
      //event.target.innerText
    );
    this.setState({ loading: true });
    this.setState({ loadingclose: false });
    const idute = AutenticationService.getIdUte();
    const data = { id: 1, method: 'ctlcaldaia', timer: 0, idute: idute, onoff :'1' };
    this.setState({ msgremoteopen: 'Avvio Richiesta status caldaia' });

    CaldaiaSrv.getOpenCaldaiaBasic(data)
      .then((response) => this.handleResponse(response, 'onoff'))
      .catch((error) => this.handleError(error, 'onoff'));
    
  };
  OnCaldaia = (event) => {
    console.log(
      'OUTPUT: CancelloComponent -> OnCaldaia -> ',
      event.target.innerText
    );
    this.setState({ loading: true });
    this.setState({ loadingclose: false });
    const idute = AutenticationService.getIdUte();
    const data = { id: 1, method: 'oncaldaia', timer: 0, idute: idute, onoff :'1' };
    this.setState({ msgremoteopen: 'Avvio Richiesta Accensione Caldaia' });

    CaldaiaSrv.getOpenCaldaiaBasic(data)
      .then((response) => this.handleResponse(response, 'open'))
      .catch((error) => this.handleError(error, 'open'));
    
  };
  OffCaldaia = (event) => {
    console.log(
      'OUTPUT: CancelloComponent -> CloseCancello -> ',
      event.target.innerText
    );
    this.setState({ msgremote: 'Avvio Richiesta Close Cancello' });
    const idute = AutenticationService.getIdUte();
    const data = { id: 0, method: 'offcaldaia', timer: 0, idute: idute, onoff :'0' };
    CaldaiaSrv.getOpenCaldaiaBasic(data)
      .then((response) => this.handleResponse(response, 'close'))
      .catch((error) => this.handleError(error, 'close'));
    this.setState({ loading: false });
    this.setState({ loadingclose: true });
  };
}

/* <div className='CancelloComponent mt-5'>
        <div className='container-fluid'>
          <section className='py-3'>
            <div className='container text-center'>
              <h3 className='mb-2'>Apre Chiude il Cancello</h3>

              <button
                className='btn btn-primary mt-2 mybut'
                //href='#'
                onClick={this.OpenCancello}
              >
                <h1>
                  <b>Apre</b>
                </h1>
                <p className='lead text-left'>messaggio di ritorno</p>
              </button>
            </div>

            <div className='container text-center py-4'>
              <button
                className='btn btn-primary mt-2 mybut'
                //href='#'
                onClick={this.CloseCancello}
              >
                <h1>
                  <b>Chiude</b>
                </h1>
                <p className='lead text-left'>messaggio di ritorno</p>
              </button>
            </div>
          </section>
        </div>
      </div> */
